import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const StatCard = ({ stat, index }) => {
  const [count, setCount] = useState(0);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!isInView) return;

    const target = typeof stat.value === 'string' ? parseInt(stat.value.replace(/[^0-9]/g, '')) : stat.value;
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [isInView, stat.value]);

  const formatValue = (val) => {
    if (typeof stat.value === 'string') {
      if (stat.value.includes('$')) return stat.value;
      if (stat.value.includes('%')) return stat.value;
      return stat.value;
    }
    return val;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      onViewportEnter={() => setIsInView(true)}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-slate-800 border border-slate-700 rounded-lg p-6 hover:border-blue-500 transition-all duration-300"
    >
      <h3 className="text-sm font-medium text-gray-400 mb-2">{stat.label}</h3>
      <p className="text-3xl font-bold text-white">
        {isInView ? formatValue(count) : '0'}
      </p>
    </motion.div>
  );
};

export default StatCard;